import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { PostRequiredInfoRequest, PostErrorResponse } from './types';
import { GetRequiredInfoResponse } from '../get';

export const postRequiredInfo = async (data: PostRequiredInfoRequest, lang = 'en', token: string | null | undefined): Promise<GetRequiredInfoResponse> => {
	const headers = {
		'Content-Type': 'application/json',
		...(token && { "X-XSRF-TOKEN": token }),
	};
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/signin/required-info?${queryParams.join('&')}`, {
		method: 'POST',
		credentials: 'include',
		headers: headers,
		body: JSON.stringify(data),
	})
		.then((res) => {
			if (res.ok) return res.json().then(response => response as GetRequiredInfoResponse);
			return res.json().then(errorResponse => {
				throw errorResponse as PostErrorResponse
			});
		})
		.then((successResponse) => successResponse)
		.catch((error: PostErrorResponse) => {
			throw error;
		});
};